import styled from 'styled-components';
import Slider from 'react-slick';

import { palette } from 'src/styles/colors';
import { layout } from 'styles/layout';

export const RecommendationCarouselContainer = styled.div`
  padding: 0 2em;
  position: relative;
  max-width: 1212px;
  margin: 4rem auto 4rem;
`;

export const ChevronContainer = styled.div`
  align-self: center;
  justify-self: center;
  position: relative;
  cursor: pointer;
  transition: opacity ease-in-out 300ms;
`;

export const RecommendationsSliderContainer = styled.div`
  position: relative;

  @media screen and (max-width: ${layout.subMd}) {
    .slick-arrow {
      display: none !important; //!important needed to override the inline display
    }
  }

  .slick-dots {
    bottom: -42px;

    button:before {
      font-size: 12px;
    }
  }
`;

export const RecommendationsSlider = styled(Slider)`
  transition: transform ease-in-out 250ms;

  a {
    color: ${palette.text};
    text-decoration: none;
  }
`;

export const Recommendation = styled.div`
  background: ${palette.white};
  box-shadow: 0 0 0.922676px rgba(0, 0, 0, 0.05), 0 0.922676px 18.4535px rgba(0, 0, 0, 0.15);
  height: 250px;
  margin: 16px 15px;
  overflow: hidden;

  @media screen and (min-width: ${layout.sm}) {
    height: 344px;
  }
`;

export const RecommendationTitle = styled.div`
  padding: 12px;
  align-self: center;
  min-height: 90px;
  box-sizing: border-box;
`;

export const RecommendationImage = styled.div`
  height: 100%;
  align-self: end;

  & > div {
    height: 100%;
  }
`;
